__turbopack_context__.v({
  "actions": "sv_Npa_actions",
  "avatar": "sv_Npa_avatar",
  "comingSoonLabel": "sv_Npa_comingSoonLabel",
  "disabled": "sv_Npa_disabled",
  "helpDesktop": "sv_Npa_helpDesktop",
  "helpDesktopAnchor": "sv_Npa_helpDesktopAnchor",
  "helpInvoker": "sv_Npa_helpInvoker",
  "helpMobile": "sv_Npa_helpMobile",
  "logo": "sv_Npa_logo",
  "navigation": "sv_Npa_navigation",
  "notification": "sv_Npa_notification",
  "notificationBadge": "sv_Npa_notificationBadge",
  "notificationBtn": "sv_Npa_notificationBtn",
  "profile": "sv_Npa_profile",
  "search": "sv_Npa_search",
  "searchSlotWrap": "sv_Npa_searchSlotWrap",
  "searchbar": "sv_Npa_searchbar",
  "selector": "sv_Npa_selector",
  "topbarLeft": "sv_Npa_topbarLeft",
  "topbarRight": "sv_Npa_topbarRight",
  "wrapper": "sv_Npa_wrapper",
});
